import { render, staticRenderFns } from "./AiChatPredefinedMessages.vue?vue&type=template&id=1da5edc6&"
import script from "./AiChatPredefinedMessages.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AiChatPredefinedMessages.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports